/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCalls = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M22.042 41.959c4.322 4.322 9.34 8.043 13.56 10.83 4.681 3.091 10.79 2.76 15.628-.493l6.707-4.511-12.955-9.917-6.551 6.504-2.824-.005-15.974-15.974-.005-2.823 6.505-6.552-9.918-12.955-4.51 6.707C8.45 17.61 8.12 23.717 11.21 28.4c2.787 4.22 6.508 9.237 10.83 13.56Zm11.355 14.168c-4.346-2.87-9.603-6.759-14.184-11.34-4.58-4.581-8.47-9.837-11.34-14.184-4.099-6.208-3.516-14.075.512-20.065l6.066-9.019 3.247-.1L30.37 17.974l-.169 2.624-6.33 6.377 13.156 13.155 6.376-6.33 2.625-.169L62.58 46.302l-.1 3.248-9.019 6.065c-5.99 4.029-13.857 4.611-20.065.512Z",
  clipRule: "evenodd"
})));

export default SvgCalls;